import Image from "next/image";
import Link from "next/link";
import PlayIcon from "@/components/icons/PlayIcon";

export default function NextCallsSection() {
  return (
    <section id="next-calls-section">
      <div className="flex justify-center w-full p-10 px-[18px] lg:px-18">
        <div className="flex flex-col justify-between w-full max-w-[1200px] bg-[#F8F9FA] border overflow-hidden border-[#0D2A4C08] lg:h-[560px] rounded-[12px]">
          <div className="w-full px-[26px] lg:px-14 pt-8 lg:pt-14 flex flex-col gap-3 lg:gap-5 z-20">
            <h1 className="lg:!text-7xl tracking-tighter !text-[32px] leading-[37px] lg:leading-[78px] !font-semibold max-w-[267px] lg:max-w-[584px] text-wrap text-start text-[#0D2A4C]">
              Your Next 10 Sales Calls Start Here
            </h1>
            <div className="flex items-center gap-2 lg:gap-2.5">
              <Link
                href="/pricing"
                className="bg-[#2A8DFF] hover:bg-[#2A8DFF]/90 text-center active:outline-1 active:outline-[#2A8DFF] active:bg-[#2A8DFF] cursor-pointer px-[18px] lg:px-8 py-[11px] lg:py-[18px] rounded-[100px]"
              >
                <p className="text-sm lg:text-lg text-white tracking-tight font-semibold">
                  Get Started Now
                </p>
              </Link>
              <Link
                href="/demo-form"
                className="bg-white px-[18px] cursor-pointer text-center hover:bg-[#2A8DFF]/5 active:outline-1 active:!outline-white active:bg-white lg:px-8 py-[11px] lg:py-[18px] border border-[#0D2A4C08] rounded-[100px] flex lg:gap-2.5 items-center"
              >
                <p className="text-sm lg:text-lg text-[#0D2A4C] font-semibold">
                  Book a Demo
                </p>
                <PlayIcon className="hidden lg:block text-[#0D2A4C]" />
              </Link>
            </div>
          </div>
          <div className="hidden lg:block z-10">
            <Image
              src="/images/next-calls.webp"
              alt="Next Calls"
              width={2240}
              height={526}
              className="w-full z-10"
            />
          </div>
          <div className="block lg:hidden pt-5">
            <Image
              src="/images/next-calls-mobile.webp"
              alt="Next Calls"
              width={703}
              height={332}
              className="w-full z-10"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
